import React from "react";
import { Reveal } from "./Reveal";

export function PageHero({ overline, title, subtitle, children }) {
  return (
    <section className="relative overflow-hidden border-b border-[#e4e9f0] bg-[#f6f8fb] grain" data-testid="page-hero">
      <div className="absolute inset-0 dot-grid opacity-40" />
      <div className="pn-container relative py-20 md:py-28">
        <Reveal>
          <p className="overline">{overline}</p>
          <h1 className="mt-4 max-w-4xl font-head text-4xl font-light leading-[1.05] tracking-tight text-[#16181D] md:text-6xl">
            {title}
          </h1>
          {subtitle && <p className="mt-6 max-w-2xl text-lg leading-relaxed text-[#4a4d52]">{subtitle}</p>}
          {children}
        </Reveal>
      </div>
    </section>
  );
}
